import React from "react";
import FooterView from "./FooterView";
import { FooterProps, UseFooterProps } from "./type";
import { useFooter } from "./useFooter";

function Footer(props: FooterProps) {
  const hook: UseFooterProps = useFooter(props);

  return <FooterView props={props} hook={hook} />;
}
export default React.memo(Footer);
